module.exports = __webpack_public_path__ + "media/images/icons/checkmark-da105f3c0c33f11e8f71ed4fd244fa6a.svg";